/**
 * Utility function to check if DEV MODE is enabled
 * DEV MODE is enabled if:
 * 1. User has explicitly enabled it (localStorage = 'true')
 * 2. User hasn't set preference AND NOT running on production domain
 * 3. User explicitly disabled it (localStorage = 'false') → DISABLED
 */
export function isDevModeEnabled() {
  if (typeof window === 'undefined') return false;
  
  const userPreference = localStorage.getItem('corvana_dev_mode');
  
  // If user explicitly set preference, respect it
  if (userPreference === 'false') return false;
  if (userPreference === 'true') return true;
  
  // If no user preference, show only on localhost/development
  const hostname = window.location.hostname;
  const isDevelopment = hostname.includes('localhost') || hostname.includes('127.0.0.1');
  
  return isDevelopment;
}

/**
 * Toggle DEV MODE on/off
 */
export function toggleDevMode() {
  const currentState = isDevModeEnabled();
  const newState = !currentState;
  
  localStorage.setItem('corvana_dev_mode', String(newState));
  
  // Reload to apply changes across all components
  window.location.reload();
}

/**
 * Get DEV MODE banner offset for positioning
 * Returns the top offset value for sticky headers
 */
export function getDevModeOffset() {
  return isDevModeEnabled() ? '52px' : '0px';
}

/**
 * Get CSS class for dev mode offset
 */
export function getDevModeClass(withBanner = true) {
  if (!withBanner) return '';
  return isDevModeEnabled() ? 'top-[52px]' : 'top-0';
}
